import React, { useState, useEffect } from 'react';
import '../css/ActivityLoggingPage.css';
import UserFooter from './UserFooter';
import ProfileNavBar from './ProfileNavBar';
import ChatBot from './ChatBot';
import Footer from './Footer';

const SetWorkoutGoals = () => {
  const userData = JSON.parse(sessionStorage.getItem('user'));
  const userID = userData.userID;

  const [planName, setPlanName] = useState('');
  const [activities, setActivities] = useState([{
    activityName: '',
    activityUnit: '',
    activityValue: '',
    activityVariance: ''
  }]);

  const [activePlan, setActivePlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchActivePlan = async () => {
    try {
      const res = await fetch('https://18.117.231.157/api/getUserActivePlanGoals', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userID }),
      });

      const result = await res.json();
      if (result.success) {
        setActivePlan(result.data);
      }
    } catch (err) {
      console.error('Error fetching plan goals:', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    

    fetchActivePlan();
  }, [userID]);

  const handleAddActivity = () => {
    setActivities([...activities, {
      activityName: '',
      activityUnit: '',
      activityValue: '',
      activityVariance: ''
    }]);
  };

  const handleChange = (index, field, value) => {
    const updated = [...activities];
    updated[index][field] = value;
    setActivities(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (activePlan) {
      const confirmed = window.confirm('You already have an active plan. Are you sure you want to overwrite it?');
      if (!confirmed) return;
    }

    try {
      const res = await fetch('https://18.117.231.157/api/createUserPlan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userID,
          planName,
          activities
        })
      });

      const result = await res.json();
      if (result.success) {
        alert('Plan created successfully!');
        fetchActivePlan();
        setPlanName('');
        setActivities([{
          activityName: '',
          activityUnit: '',
          activityValue: '',
          activityVariance: ''
        }]);
      } else {
        alert('Failed to create plan.');
      }
    } catch (error) {
      console.error('Error creating plan:', error);
    }
  };

  return (
    <div>
      <ProfileNavBar />
      <br /><br /><br /><br /><br />

      <h2 className='contactuspageheaders'>Create Your Own Goals</h2>

      {!loading && activePlan && (
        <div className="logTile" style={{ padding: '1.5rem', marginBottom: '2rem' }}>
          <h2 style={{ textAlign: 'center' }}>📊 Active Plan: {activePlan.planName}</h2>
          <div className="grid-container2">
            {activePlan.activities.map((activity, index) => (
              <div key={index} className="activity-tile" style={{ padding: '1rem', border: '1px solid #ccc', borderRadius: '10px' }}>
                <h3 style={{ textAlign: 'center' }}>{activity.activityName}</h3>
                <p><strong>Daily Goal:</strong> {activity.dailyGoal} {activity.activityUnit}</p>
                <p><strong>Weekly Goal:</strong> {activity.weeklyGoal} {activity.activityUnit}</p>
                <p><strong>Monthly Goal:</strong> {activity.monthlyGoal} {activity.activityUnit}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <form className='loginform' onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Plan Name"
          value={planName}
          onChange={e => setPlanName(e.target.value)}
          required
        />

        {activities.map((activity, index) => (
          <div key={index} style={{ border: '1px solid #ccc', paddingLeft: '1%', paddingRight: '1%', marginBottom: '1rem', borderRadius: '8px' }}>
            <input
              type="text"
              placeholder="Activity Name"
              value={activity.activityName}
              onChange={e => handleChange(index, 'activityName', e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Activity Unit (e.g. mins, steps)"
              value={activity.activityUnit}
              onChange={e => handleChange(index, 'activityUnit', e.target.value)}
              required
            />
            <div className='rowtype'>
              <input
                type="number"
                placeholder="Target Value"
                value={activity.activityValue}
                onChange={e => handleChange(index, 'activityValue', e.target.value)}
                required
              />
              <input
                type="number"
                placeholder="+ or -"
                style={{ width: '13.6%', fontSize: '1.3rem' }}
                readOnly
              />
              <input
                type="number"
                placeholder="0"
                value={activity.activityVariance}
                onChange={e => handleChange(index, 'activityVariance', e.target.value)}
              />
            </div>
          </div>
        ))}

        <button type="button" onClick={handleAddActivity} style={{ marginBottom: '1rem', padding: '0.5rem 1rem' }}>
          ➕ Add Another Activity
        </button>
        <br />
        <button type="submit" style={{ padding: '0.75rem 1.5rem', backgroundColor: '#38bdf8', border: 'none', color: 'white', borderRadius: '6px' }}>
          Submit Plan
        </button>
      </form>

      <br /><br />
      <ChatBot />
      <UserFooter />
      <Footer />
    </div>
  );
};

export default SetWorkoutGoals;
